import { createSlice } from "@reduxjs/toolkit";
import {
  getHomePageSetting,
  raiseQuery,
  getSetting,
  getPrivacyData,
  getCancellationPolicy,
  getAbout_US,
  getTerms,
  getStaticPage,
} from "./actions";
import _ from "lodash";

const initialState = {
  homePageSetting: [],
  setting: null,
  cancellPolicy: null,
  about_Us: null,
  termsData: null,
  staticPageData: [],
  privacyData: null,
  current_Language: null,
};

const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    change_Language: (state, action) => {
      state.current_Language = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomePageSetting.fulfilled, (state, action) => {
      state.homePageSetting = _.sortBy(
        _.filter(action?.payload?.data?.data, { isVisible: true }),
        ["id"]
      );
    });
    builder.addCase(getSetting.fulfilled, (state, action) => {
      state.setting = action?.payload?.data;
    });
    builder.addCase(getPrivacyData.fulfilled, (state, action) => {
      state.privacyData = action?.payload?.data?.content;
    });
    builder.addCase(getCancellationPolicy.fulfilled, (state, action) => {
      state.cancellPolicy = action?.payload?.data;
    });
    builder.addCase(getAbout_US.fulfilled, (state, action) => {
      state.about_Us = action?.payload?.data;
    });
    builder.addCase(getTerms.fulfilled, (state, action) => {
      state.termsData = action?.payload?.data;
    });
    builder.addCase(getStaticPage.fulfilled, (state, action) => {
      state.staticPageData = action?.payload?.data;
    });
    builder.addCase(raiseQuery.fulfilled, (state, action) => {});
  },
});

export const { change_Language } = slice.actions;

export default slice.reducer;
